import React, { useCallback, useEffect, useState } from "react";
import Layout from "../components/Layout";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

function rankColor(rank) {
  if (rank === 1) return "text-[#f7931a] text-glow-gold";
  if (rank === 2) return "text-[#a0aec0]";
  if (rank === 3) return "text-[#ff6b00]";
  return "text-[#8b95a9]";
}

function leaderboardUrl(tab) {
  if (tab === "global") return "/leaderboard/global";
  if (tab === "weekly") return "/leaderboard/weekly";
  return "/leaderboard/friends";
}

export default function Leaderboard() {
  const { user } = useAuth();
  const [tab, setTab] = useState("global");
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    const { data } = await api.get(leaderboardUrl(tab));
    setEntries(data.entries || []);
    setLoading(false);
  }, [tab]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <Layout>
      <div className="px-4 py-5 flex flex-col gap-4" data-testid="leaderboard-page">
        <h1 className="font-pixel text-[14px] text-glow-green">
          ▲ HIGH SCORES
        </h1>

        <div className="grid grid-cols-3 gap-2">
          {[
            { id: "global", label: "GLOBAL" },
            { id: "weekly", label: "WEEK" },
            { id: "friends", label: "FRIENDS" },
          ].map((t) => (
            <button
              key={t.id}
              onClick={() => setTab(t.id)}
              data-testid={`lb-tab-${t.id}`}
              className={`py-2 rounded-[8px] font-pixel text-[9px] border transition-colors ${
                tab === t.id
                  ? "bg-[#2ecc71] text-[#0f0f1e] border-[#2ecc71]"
                  : "bg-transparent text-[#8b95a9] border-[rgba(46,204,113,0.3)] hover:border-[#2ecc71]"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="text-[11px] text-[#8b95a9]">Loading...</div>
        ) : entries.length === 0 ? (
          <div className="cb-card p-5 text-center text-[11px] text-[#8b95a9]">
            No scores yet. Be the first!
          </div>
        ) : (
          <div className="cb-card p-3 font-mono">
            {entries.map((e) => {
              const mine = user && e.user_id === user.id;
              const score =
                tab === "weekly" ? e.weekly_score : e.all_time_best;
              return (
                <div
                  key={`${tab}-${e.user_id}`}
                  className={`flex items-center justify-between py-2 px-2 border-b border-[rgba(46,204,113,0.12)] last:border-b-0 ${
                    mine ? "bg-[rgba(46,204,113,0.08)]" : ""
                  }`}
                  data-testid={`lb-row-${e.rank}`}
                >
                  <div className="flex items-center gap-3">
                    <span
                      className={`font-pixel text-[11px] w-8 ${rankColor(e.rank)}`}
                    >
                      #{e.rank}
                    </span>
                    <span
                      className={`text-[13px] truncate max-w-[140px] ${
                        mine ? "text-[#2ecc71]" : "text-white"
                      }`}
                    >
                      {e.username}
                    </span>
                  </div>
                  <span className="text-[#f7931a] text-glow-gold text-[13px]">
                    {score ?? 0}
                  </span>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </Layout>
  );
}
